import { Heading as i } from "@tiptap/extension-heading";
import { VueNodeViewRenderer as s } from "@tiptap/vue-3";
import { nanoid as d } from "nanoid";
import { z as a } from "zod";
import { getAttrs as g } from "../../../helpers/getAttrsFromHTML.js";
import { extendEditorVueNode as l } from "../../../helpers/nodeFactory.js";
import { renderVueElement as u } from "../../../helpers/staticRendering.js";
import { toggleCommandFactory as n } from "../../../helpers/toggleCommands.js";
import m from "./CustomHeading.vue.js";
import c from "./headingOneIcon.svg.js";
import f from "./headingThreeIcon.svg.js";
import p from "./headingTwoIcon.svg.js";
import h from "./ScalarHeading.vue.js";
const O = [
  {
    id: 17,
    name: "Heading 1",
    command: ({ editor: e, range: t }) => n(e, t, {
      name: "toggleHeading",
      params: { level: 1 }
    }),
    hotkey: "⌘ ⇧ 1",
    markdown: "# MARKDOWN",
    svg: c
  },
  {
    id: 18,
    name: "Heading 2",
    command: ({ editor: e, range: t }) => n(e, t, {
      name: "toggleHeading",
      params: { level: 2 }
    }),
    hotkey: "⌘ ⇧ 1",
    markdown: "## MARKDOWN",
    svg: p
  },
  {
    id: 19,
    name: "Heading 3",
    command: ({ editor: e, range: t }) => n(e, t, {
      name: "toggleHeading",
      params: { level: 3 }
    }),
    hotkey: "⌘ ⇧ 1",
    markdown: "### MARKDOWN",
    svg: f
  }
], o = "custom_heading", R = {
  tagName: o,
  attributeTransform: (e, t) => {
    const r = a.object({
      slug: a.string(),
      level: a.coerce.number().int(),
      uid: a.string().default(d())
    }).safeParse(t);
    return r.success ? r.data : null;
  }
}, S = {
  name: o,
  render: (e) => u(h, { id: e.slug, level: e.level })
}, T = l(
  {
    name: o,
    vueComponent: m,
    baseNode: i,
    draggable: !0,
    addAttributes: () => ({
      level: {
        default: 1
      },
      slug: {
        default: ""
      },
      uid: {
        default: ""
      }
    })
  },
  {
    allowGapCursor: !1,
    selectable: !0,
    draggable: !0,
    /** Custom addNodeView function to handle dynamic element bug below */
    addNodeView() {
      return s(m, {
        update: ({ oldNode: e, newNode: t, updateProps: r }) => t.type.name !== this.name || t.attrs !== e.attrs ? !1 : (r(), !0)
      });
    },
    addKeyboardShortcuts() {
      return {
        Backspace: () => {
          const { empty: e, $anchor: t } = this.editor.state.selection, r = t.pos === 1;
          return !e || t.parent.type.name !== this.name ? !1 : r || !t.parent.textContent.length ? this.editor.commands.clearNodes() : !1;
        }
      };
    },
    parseHTML() {
      return [
        {
          tag: o,
          getAttrs: g
        },
        ...this.options.levels.map((e) => ({
          tag: `h${e}`,
          attrs: { level: e }
        })),
        {
          tag: "h6",
          getAttrs: () => ({ level: 5 })
        }
      ];
    }
  }
);
export {
  S as customHeadingStatic,
  T as default,
  O as headingSuggestions,
  R as markdownHeadingDirective
};
